import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDependentGetAllQueryResponse,
  GetApiDependentGetAllQueryParams,
  GetApiDependentGetAll401,
  GetApiDependentGetAll403,
} from "../../../types/GetApiDependentGetAll";

export function getGetApiDependentGetAllUrl() {
  return `/api/Dependent/get-all` as const;
}

/**
 * {@link /api/Dependent/get-all}
 */
export async function getApiDependentGetAll(
  params?: GetApiDependentGetAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDependentGetAllQueryResponse,
    ResponseErrorConfig<GetApiDependentGetAll401 | GetApiDependentGetAll403>,
    unknown
  >({
    method: "GET",
    url: getGetApiDependentGetAllUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
